exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".o-jl-links{display:-webkit-box;display:-ms-flexbox;display:flex;font-size:1.5rem;padding:0 .5em 1em}.o-jl-links__link{-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto;text-align:center}", ""]);

// exports
